const services = [
  { icon: "ri-code-box-line", label: "Custom business applications" },
  { icon: "ri-flow-chart", label: "Workflow automation systems" },
  { icon: "ri-archive-line", label: "Operations and inventory platforms" },
  { icon: "ri-team-line", label: "HR, performance, and workforce systems" },
  { icon: "ri-plug-line", label: "Integration with existing tools" },
];

export default function WhatWeDo() {
  return (
    <section className="py-12 md:py-16">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">What We Do</h2>
          <p className="text-base text-silver-300 mb-8 max-w-2xl">
            We build software that fits your operations, not the other way around.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {services.map((s) => (
              <div key={s.label} className="glass-card p-5 flex items-center gap-4 group">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-graphite-800 group-hover:bg-emerald-accent/10 transition-colors flex-shrink-0">
                  <i className={`${s.icon} text-lg text-emerald-accent group-hover:scale-110 transition-transform duration-300`} />
                </div>
                <span className="text-sm font-medium text-white group-hover:text-emerald-soft transition-colors duration-300">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}